module.exports = __webpack_public_path__ + "produce-fresh-grass-02.jpg?0dc3d758d73ddf65c7734907d892be8d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-02.jpg
// module id = 39
// module chunks = 0